import { FormDataAPIType } from 'components/common/form/index';
import { useFormState } from 'react-hook-form';
import { Box, Button, Container } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';
import React, { useEffect, useRef, useState } from 'react';

export default function FormOnPageSaveButton({ hookForm }: { hookForm: FormDataAPIType }) {
    const { isDirty } = useFormState({ control: hookForm.form.hookFormControl });
    const label = (hookForm.form.formTranslation && hookForm.form.formTranslation('next_define_details', {})) ?? '';

    const resizeObserver = useRef<any>(null);
    const [scrollIndent, setScrollIndent] = useState<number>(0);

    const adjustScrollIndent = () => {
        const formComponentsHolder: any = document.querySelector('.default-components.scroll-content-container');
        if (formComponentsHolder) {
            setScrollIndent(formComponentsHolder.offsetWidth - formComponentsHolder.clientWidth);
        }
    };
    useEffect(() => {
        const formComponentsHolder = document.querySelector('.default-components.scroll-content-container');

        adjustScrollIndent();
        if (formComponentsHolder) {
            //adjust on resize tab container
            resizeObserver.current = new ResizeObserver(adjustScrollIndent);
            resizeObserver.current.observe(formComponentsHolder);
        }
        return () => {
            if (resizeObserver.current) resizeObserver.current.disconnect();
        };
    }, []);

    return (
        <Box
            sx={{
                pr: (scrollIndent ? scrollIndent : 0) + 'px',
            }}
        >
            <Container maxWidth={'sm'} disableGutters={true}>
                <Button
                    type="submit"
                    data-test={`next-button`}
                    variant={isDirty ? 'contained' : 'outlined'}
                    endIcon={<IconMi icon="arrow-right" />}
                >
                    {label}
                </Button>
            </Container>
        </Box>
    );
}
